import { Injectable } from '@angular/core';
import { Observable, shareReplay, throwError } from 'rxjs';
import SafeUrlAssembler from 'safe-url-assembler';
import { ApiEndpointService } from '../../core/services/api-endpoint.service';
import { HttpClientService } from '../../core/services/http/http-client.service';
import { INotifyTemplate } from '../models/notify-template.interface';

@Injectable()
export class NotifyTemplateService {
    private cachedNotifyTemplates: INotifyTemplate[];

    constructor(private httpClientService: HttpClientService, private apiEndpointService: ApiEndpointService) {
    }

    public getNotifyTemplates(): Observable<INotifyTemplate[]> {

        const endpoint = SafeUrlAssembler()
            .template(this.apiEndpointService.getEndpoint('getNotifyTemplates'))
            .toString();

        return this.httpClientService.get<INotifyTemplate[]>(endpoint)
                   .pipe(shareReplay(1));
    }

    public getNotifyTemplate(templateId: string): Observable<INotifyTemplate> {
        const endpoint = SafeUrlAssembler()
            .template(this.apiEndpointService.getEndpoint('getNotifyTemplate'))
            .param('templateId', templateId)
            .toString();

        return this.httpClientService.get<INotifyTemplate>(endpoint);
    }

    public addNotifyTemplate(template: INotifyTemplate): Observable<Response> {
        const endpoint = SafeUrlAssembler()
            .template(this.apiEndpointService.getEndpoint('addNotifyTemplate'))
            .toString();

        return this.httpClientService.post<Response>(endpoint, template);
    }

    public setPrimaryNotifyTemplate(templateId: string): Observable<Response> {
        const endpoint = SafeUrlAssembler()
            .template(this.apiEndpointService.getEndpoint('setPrimaryNotifyTemplate'))
            .param('templateId', templateId)
            .toString();
        return this.httpClientService.put<Response>(endpoint, {});
    }

    public deleteNotifyTemplate(templateId: string): Observable<Response> {
        const endpoint = SafeUrlAssembler()
            .template(this.apiEndpointService.getEndpoint('deleteNotifyTemplate'))
            .param('templateId', templateId)
            .toString();

        return this.httpClientService.delete<Response>(endpoint);
    }

    public uploadTemplatePhoto(files: FileList, description: string = ''): Observable<Response> {
        if (!files || !files.length) {
            throwError(() => new Error('An image is required'));
        }

        const endpoint = SafeUrlAssembler()
            .template(this.apiEndpointService.getEndpoint('uploadFiles'))
            .toString();

        return this.httpClientService.uploadFiles<Response>(endpoint, files, true);
    }

    public clearCache() {
        this.cachedNotifyTemplates = null;
    }
}
